import React from "react";
import ReactDOM from "react-dom";
import TagManager from "react-gtm-module";
import App from "./App";
import "./components/layout.css";

// Working with GTM
if (process.env.NODE_ENV === "production") {
  const tagManagerArgs = {
    gtmId: "GTM-K86V5LN",
  };
  TagManager.initialize(tagManagerArgs);
  console.log("GTM is connected...");
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
